export default {
    configuration: true,
    searchList: {
        searchTxt: [
            {
                name: '车牌',
                value: 'licensePlateNo',
                type: 'input',
                unfold: true,
                span: 4
            },
            {
                name: '车型',
                value: 'carTypeNameCn',
                type: 'input',
                unfold: true,
                span: 4
            }
        ],
        unfoldState: false,
        advancedBtn: false
    },
    table: {
        height: 400,
        leftOperation: true,
        leftWidth: 80,
        selectBtn: true,
        columns: [
            {
                label: '车牌',
                prop: 'licensePlateNo',
                sort: true,
                width: 180
            },
            {
                label: '车型代码',
                prop: 'carType',
                sort: true,
                width: 150
            },
            {
                label: '车型',
                prop: 'carTypeNameCn',
                sort: true,
                width: 120
            },
            {
                label: '创建人',
                prop: 'createUserName',
                sort: true,
                width: 120
            },
            {
                label: '创建时间',
                prop: 'createTime',
                sort: true,
                width: 135
            }
        ],
        action: [
            {
                type: 'text',
                label: '删除',
                size: 'small',
                event: 'del'
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [10, 20, 30, 50]
    },
    searchTotalTitle: []
};
